import { AnnotationClasses, AnnotationValidation } from '../types'

export const getAnnotationStatus = (
  annotationValidation: AnnotationValidation,
  annotationClasses: AnnotationClasses
) => {
  if (annotationClasses === 'UNDEFINED') {
    return 'NOT_ANNOTATED'
  }

  if (annotationValidation === 'INVALID') {
    return 'INVALID'
  }

  if (annotationClasses === 'DEFINED_EMPTY') {
    return 'EMPTY'
  }

  if (annotationClasses === 'DEFINED') {
    return 'ANNOTATED'
  }

  return undefined
}
